import partner from "~/utils/partner";

const checkApiByParnerId = () => {
  const hostname = window.location.hostname;
  if (hostname.includes("beta")) {
    return "https://api-111.medpro.com.vn:5000";
    // return "https://api-v2.medpro.com.vn:5000";
  }

  switch (partner) {
    case "choray":
      return "https://api-112.medpro.com.vn:5000";

    // case "dalieuhcm":
    //   return "https://api-113.medpro.com.vn:5000";

    case "nhidong1":
      return "https://api-114.medpro.com.vn:5000";

    case "trungvuong":
      return "https://api-115.medpro.com.vn:5000";

    case "binhthanhhcm":
    case "pkdkanhao":
      return "https://api-116.medpro.com.vn:5000";

    case "umc":
      return "https://api-117.medpro.com.vn:5000";

    default:
      return "https://api-v2.medpro.com.vn:5000";
  }
};

// Api backend
export const RESTFULL_API_URL = checkApiByParnerId();

// Api hình ảnh và nội dung
export const STATIC_CONTENT_API_URL = `https://resource.medpro.com.vn`;

// Link login tới medproId
export const MEDPRO_LOGIN = `https://id-v121.medpro.com.vn/check-phone`;
//  trên cổi đời này không còn nhánh id-v120 , id-v110 nữa . mãi mãi !

// Thời gian sống 12*60*60; // 12 tiếng
export const COOKIE_EXPIRES = 43200;

// wechat
export const SOCKET_CHAT = "wss://alpha-api.medpro.com.vn/cable";

// link thanh toán paymenthub
export const PAYMENT_HUB_URL =
  "https://payment-gateway-qrcode-testing.medpro.com.vn";

export const LINK_API_COVID19 = "https://covid19-vaccine.medpro.com.vn";
